module.exports = __webpack_public_path__ + "static/media/profile-cart-icon.423ede64.svg";